import { curry } from 'ramda';
import { IAppState } from '../../redux';
import { EServiceId } from '../../redux/reducers';
import { selectServiceById } from '../publishTerms';

export const selectBaseAuctionBetByServiceId = curry((serviceId: EServiceId, state: IAppState): number => {
  const service = selectServiceById(serviceId, state);

  return service?.baseAuctionBet || 0;
});
